import React, { FC, useMemo } from 'react';
import classNames from 'classnames';

import './TextHighlighter.styles.scss';

const escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

type TextHighlighterProps = {
  className?: string;
  text: string;
  highlighter: string | RegExp;
};

const TextHighlighter: FC<TextHighlighterProps> = ({
  className,
  text,
  highlighter,
}) => {
  const highlightedText = useMemo(() => {
    const regex =
      typeof highlighter === 'string'
        ? new RegExp(`(${escapeRegex(highlighter)})`, 'i')
        : highlighter;

    const parts = text?.split(regex);

    return parts?.map((part, index) => {
      if (index % 2 === 1) {
        return (
          <span key={index} className="text-highlighter__tag">
            {part}
          </span>
        );
      } else {
        return part;
      }
    });
  }, [highlighter, text]);

  return (
    <div className={classNames('text-highlighter', className)}>
      {highlightedText}
    </div>
  );
};

export default TextHighlighter;
